import React from "react";

export default function Footer() {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Generate 10 droplets for the jumping water effect
    const droplets = Array.from({ length: 10 });

    return (
        <footer className="bandham-footer">

            {/* --- Animated Waves & Particles Container --- */}
            <div className="waves-container">

                {/* 1. Jumping Water Droplets */}
                <div className="particles-container">
                    {droplets.map((_, index) => (
                        <span key={index} className="droplet"></span>
                    ))}
                </div>

                {/* 2. The Waves SVG */}
                <svg
                    className="waves"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 24 150 28"
                    preserveAspectRatio="none"
                    shapeRendering="auto"
                >
                    <defs>
                        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                    </defs>
                    <g className="parallax">
                        <use xlinkHref="#gentle-wave" x="48" y="0" />
                        <use xlinkHref="#gentle-wave" x="48" y="3" />
                        <use xlinkHref="#gentle-wave" x="48" y="5" />
                        <use xlinkHref="#gentle-wave" x="48" y="7" />
                    </g>
                </svg>
            </div>

            {/* --- Main Content --- */}
            <div className="footer-container">
                <div className="footer-grid">

                    {/* Brand */}
                    <div className="footer-col brand-col">
                        {/* Replace with your actual logo path */}
                        <img src="images/footerlogo.webp" alt="Bandham Logo" className="footer-logo" />
                        <p className="footer-about">
                            We Listen, We Understand, We Create. <br />
                            Handcrafted embroidery that tells your story.
                        </p>
                        <div className="social-links">
                            <a href="https://www.instagram.com/bandham.in" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                            <a href="https://www.facebook.com/profile.php?id=61585302155060" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                            <a href="https://wa.me/918897388513" target="_blank" rel="noopener noreferrer" className="icon-link social-icon" aria-label="WhatsApp">
                                <i class="fa-brands fa-whatsapp"></i>
                            </a>
                        </div>
                    </div>

                    {/* Shop */}
                    <div className="footer-col">
                        <h3 className="col-title">Collections</h3>
                        <ul className="footer-links">
                            <li><a href="/photo-embroidery">Chitra Sutram</a></li>
                            <li><a href="/hoop-embroidery">Valaya Sutram</a></li>
                            <li><a href="/accessories">Accessories</a></li>
                            <li><a href="/collection">Gift Bundles</a></li>
                        </ul>
                    </div>

                    {/* Help */}
                    <div className="footer-col">
                        <h3 className="col-title">More Info</h3>
                        <ul className="footer-links">
                            <li><a href="/track">Privacy Policy</a></li>
                            <li><a href="/shipping">Shipping Policy</a></li>
                            <li><a href="/returns">Returns & Exchange</a></li>
                            <li><a href="/faq">FAQs</a></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="footer-col">
                        <h3 className="col-title">Contact Us</h3>
                        <ul className="footer-contact">
                            <li><span>Email:</span> <br /> manabandham07@gmail.com</li>
                            <li><span>Phone:</span> <br /> +91 8897388513</li>
                            <li><span>Address:</span> <br /> Dr.No. 3d-11-4, Western Street, West Godavari District, Eluru, Andhra Pradesh - 534001</li>
                        </ul>
                    </div>
                </div>

                {/* Bottom */}
                <div className="footer-bottom">
                    <div className="big-brand-text">BANDHAM</div>
                    <div className="legal-row">
                        <span>© 2025 Bandham. All Rights Reserved.</span>
                        <span className="designer-credit">
                            Designed by <a href="https://wa.me/919603996089" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "none", fontWeight: "bold" }}>Satya Deep G</a>
                        </span>
                        <div className="legal-links">
                            <a href="/privacy">Privacy Policy</a>
                            <a href="/terms">Terms of Service</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}